module.exports = __webpack_public_path__ + "images/emoji/athletic_shoe.d81f45a7e1d4f7f1c786.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/athletic_shoe.png
// module id = HBHA
// module chunks = 1